var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CustomCurve lxn-w100 lxn-h100"},[_c('div',{staticClass:"CustomCurve-d1 lxn-w100 lxn-pos-rel"},[_vm._t("default")],2),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CustomCurve-svg-wrapper lxn-w100 lxn-pos-rel"},[_c('div',{staticClass:"CustomCurve-curve lxn-pos-abs"})])
}]

export { render, staticRenderFns }